import React from 'react';
import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AxiosInterceptorConfig, RequestConfig } from '@unifocus/js-utils';
import { hideMask, showMask } from '../maskhandler/MaskHandler';

export class ReactAxiosInterceptorConfig implements AxiosInterceptorConfig {
   private requestsMade = 0;
   private defaultRequestConfig: RequestConfig;

   constructor(defaultRequestConfig: RequestConfig) {
      this.defaultRequestConfig = defaultRequestConfig;
   }

   getDefaultRequestConfig(): RequestConfig {
      return this.defaultRequestConfig;
   }

   requestStarted(config: AxiosRequestConfig): void {
      const configAsAny = config as any;

      if (configAsAny && !configAsAny.disableLoadMasking) {
         if (this.requestsMade === 0) {
            showMask();
         }

         this.requestsMade++;
      }
   }

   requestCompletedSuccessfully(response: AxiosResponse): void {
      const configAsAny = response.config as any;

      if (configAsAny && !configAsAny.disableLoadMasking) {
         this.requestsMade--;

         if (this.requestsMade === 0) {
            hideMask();
         }
      }
   }

   requestCompletedWithError(error: AxiosError): void {
      const configAsAny = error.config as any;

      if (configAsAny && !configAsAny.disableLoadMasking) {
         this.requestsMade = 0;

         hideMask();
      }
   }
}
